<template>
	<journey-wrapper save>
		<div v-if="store.showActions">
			<app-panel v-if="store.photosSkipped" title="Photos" compact>
				<dl class="divide-y divide-gray-100">
					<list-group-item
						label="Reason for photos skipped:"
						:value="store.journey!.photo_skip_reason" />
				</dl>
			</app-panel>

			<app-panel v-else-if="skipping" title="Skip Photos">
				<fieldset aria-label="Reason for skipping photos">
					<p class="text-gray-600 text-sm mb-4">
						Please select a reason for skipping photos:
					</p>
					<app-radio-group
						v-model="store.journey!.photo_skip_reason"
						:options="reasonOptions"
						class="-space-y-px rounded-md bg-white" />
					<div v-if="store.journey!.photo_skip_reason === 'Other'" class="mt-4">
						<app-input
							v-model="store.journey!.photo_skip_reason_other"
							label="Please specify (required):"
							name="notes"
							type="textarea" />
					</div>
				</fieldset>
			</app-panel>

			<div v-else>
				<stock-summary v-if="store.journey" :journey="store.journey" />

				<app-panel title="Photos" class="mt-3">
					<app-file-button
						:value="store.journey!.photos"
						name="photos"
						multiple
						confirm
						@file-change="(files: File[]) => (store.journey!.photos = files)">
						<app-icon :icon="['fas', 'fa-camera']" class="mr-1" />
						Add Photos
					</app-file-button>
				</app-panel>
			</div>
		</div>

		<journey-nav
			:current="2"
			prev="details"
			next="signature"
			:disabled="!store.step2Complete"
			:method="
				!store.photosSaved || store.unsavedPhotos.length > 0 ? store.savePhotos : undefined
			">
			<div
				v-if="
					(!store.photos || store.photos.length == 0) &&
					!skipping &&
					!store.journey!.photo_skip_reason
				"
				class="flex underline text-gray-500 text-sm justify-center">
				<button @click="skipping = true">Skip Photos</button>
			</div>

			<div
				v-else-if="skipping || store.journey!.photo_skip_reason"
				class="flex underline text-gray-500 text-sm justify-center">
				<button @click="backToPhotos()">Back to Add Photos</button>
			</div>
		</journey-nav>
	</journey-wrapper>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import StockSummary from '@/components/partials/driver-app/StockSummary.vue'
	import JourneyNav from '@/components/partials/driver-app/JourneyNav.vue'
	import useDriverApp from '@/stores/driver-app'
	import JourneyWrapper from '@/components/layout/driver-app/JourneyWrapper.vue'
	import ListGroupItem from '@/components/partials/ListGroupItem.vue'

	// Resources
	const store = useDriverApp()

	// Data
	const skipping = ref(false)

	const reasonOptions = [
		{ name: 'Camera not working' },
		{ name: 'Customer requested no photos' },
		{ name: 'Other' }
	]

	function backToPhotos() {
		skipping.value = false
		store.journey!.photo_skip_reason = ''
		store.journey!.photo_skip_reason_other = ''
		store.photosSaved = false
	}
</script>
